import React, { Component } from 'react'
import css from './styles.scss'
import { connect } from 'react-redux'

const HelpEntry = ({ keyVal: key, type, description }) => (
  [
    <dt key={`${key}_dt`} className={css.dt}>
      {key} <span className={css.type}>{type}</span>
    </dt>,
    <dd key={`${key}_dd`} className={css.dd}>
      <p className={css.desc} style={{ display: description ? 'block' : 'none' }}>
        {description}
      </p>
    </dd>
  ]
)

export class Help extends Component {
  render () {
    const { schema } = this.props.item
    if (!schema) {
      return null
    }
    const helpList = Object.keys(schema).map((key, i) => {
      const { type, description, fields } = schema[key]
      if (type === 'array') {
        const displayedFields = Object.keys(fields).map(key => {
          const field = fields[key]
          return <HelpEntry key={key} keyVal={key} type={field.type} description={field.description} />
        })
        return [
          <dt key={`${key}_dt`} className={css.dt}>
            {key} <span className={css.type}>array</span>
          </dt>,
          <dd key={`${key}_dd`} className={css.dd}>
            <dl className={css.dlNest}>
              {displayedFields}
            </dl>
          </dd>
        ]
      }
      return <HelpEntry key={key} keyVal={key} type={type} description={description} />
    })

    return (
      <div className={css.Help}>
        <dl className={css.dl}>
          {helpList}
        </dl>
      </div>
    )
  }
}

const mapStateToProps = state => {
  const { item } = state
  return {
    item
  }
}

export default connect(mapStateToProps)(Help)



// WEBPACK FOOTER //
// /app/js/components/Help/index.js